<template>
  <v-container class="max-width-1200">

    <!-- <v-row>
      <v-col>
        <v-img
          src="https://www.rubin.hu/wp-content/uploads/2015/05/16.jpg"
          max-width="800"
          contain
          class="ml-12 mx-auto">
        </v-img>
      </v-col>
    </v-row> -->

    <v-row class="text-justify justify-center">
      <v-col>

        <v-row class="justify-center">
          <v-col>
            <v-row>
              <v-col class="pb-0 headline text-uppercase">
                {{ $t('subMetering.promo.title') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-1">
                {{ $t('subMetering.promo.subtitle.01')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t('subMetering.promo.text.01')}}
              </v-col>
            </v-row>

            <!-- pros checked -->
            <v-row class="py-8 max-width-1000 mx-auto">
              <v-col
                v-for="(item,index) in pros"
                :key="index"
                cols="12" sm="6"
                class="px-12">
                <v-row align="center">
                  <v-col cols="2"
                    style="min-width: 66px;">
                    <v-icon
                      size="42"
                      color="success">
                      mdi-checkbox-marked-outline
                    </v-icon>
                  </v-col>
                  <v-col>
                    {{ $t(item.text)}}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

          </v-col>
        </v-row>

        <v-row class="justify-center">
          <v-col>
            <v-row>
              <v-col class="display-1">
                {{ $t('common.solution')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                {{ $t('subMetering.promo.text.02')}}
              </v-col>
            </v-row>
            <v-row class="">
              <v-col>
                <v-alert
                    type="success"
                    icon="mdi-checkbox-marked-outline"
                    class="alert-icon"
                    border="left">
                    <v-col class="pb-2 title">{{ $t('energyManagement.service.energyMonitor.title')}}</v-col>
                    <v-col class="py-2">{{ $t('subMetering.promo.text.03')}}</v-col>
                    <v-col class="text-end">
                      <v-btn
                        text
                        @click="loadPage('EnergyMonitor')">
                          {{ $t("common.intrested") }}
                        </v-btn>
                    </v-col>
                  </v-alert>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-img
              src="@/assets/em/em_mockup_01.png"
              max-width="450"
              contain
              class="ml-12 mx-auto">
            </v-img>
          </v-col>
        </v-row>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Promo',
    extends: DataComponentBase,

    data: () => ({
      pros: [
        { text: "subMetering.promo.pros.01" },
        { text: "subMetering.promo.pros.02" },
        { text: "subMetering.promo.pros.03" },
        { text: "subMetering.promo.pros.04" },
      ],
    }),

    methods: {

    },
  }
</script>
